const constant = {
  PAGE_NOT_FOUND_CODE: '404',
  PAGE_NOT_FOUND_MESSAGE: 'Page Not Found',
};

export default constant;
export { constant };
